import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { CampoIdentificacao } from '../../UI';
import * as C from '../../../theme/colors.constants';

/**
 * Cabeçalho de identificação da Ficha Financeira (AW2-1077) — mesmo padrão
 * visual da aba Histórico (`IdentificacaoProcesso.jsx`: caixa `paleGrey`,
 * grid de `CampoIdentificacao`), mas com o conjunto de campos pedido pelo AC
 * desta story (Código + Nome do Cliente/Devedor, Responsável) — sem "Fase
 * atual" nem o checkbox "Limpar campos", que são específicos da aba
 * Histórico e não fazem parte deste AC.
 *
 * Somente leitura, sem fetch próprio: `dadosProcesso` já é buscado pelo
 * container (`buscarAcompanhamentoDoProcessoService`) e `processo.negociador`
 * já vem do mapper da grid — mesma fonte já usada por outras abas.
 */
export default function CabecalhoFichaFinanceira({ processo, dadosProcesso }) {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: C.navy, mb: 1 }}>
        Identificação
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(5, 1fr)' },
          rowGap: 1.5,
          columnGap: 2,
          backgroundColor: C.paleGrey,
          border: `1px solid ${C.borderGrey}`,
          borderRadius: 1.5,
          p: 2,
        }}
      >
        {/* Nome de Cliente/Devedor vem de `processo` (síncrono, já disponível
            no momento da seleção na grid — mesma fonte de `IdentificacaoProcesso.jsx`),
            não de `dadosProcesso` (populado só depois do fetch de
            acompanhamento resolver) — evita um flicker "—" ao trocar de
            processo. `dadosProcesso` só é necessário para os códigos, que
            não têm outra fonte síncrona. */}
        <CampoIdentificacao label="Código do Cliente" value={dadosProcesso?.codigoCliente} />
        <CampoIdentificacao label="Nome do Cliente" value={processo?.nomeCliente} />
        <CampoIdentificacao label="Código do Devedor" value={dadosProcesso?.codigoDevedor} />
        <CampoIdentificacao label="Nome do Devedor" value={processo?.nomeDevedor} />
        <CampoIdentificacao label="Responsável" value={processo?.negociador} />
      </Box>
    </Box>
  );
}
CabecalhoFichaFinanceira.propTypes = {
  processo: PropTypes.shape({
    negociador: PropTypes.string,
    nomeCliente: PropTypes.string,
    nomeDevedor: PropTypes.string,
  }),
  dadosProcesso: PropTypes.shape({
    codigoCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    codigoDevedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};
CabecalhoFichaFinanceira.defaultProps = {
  processo: null,
  dadosProcesso: null,
};
